
import React from 'react';

import ProjectBussy from './ProjectBussy';

const Loading = () => {
    return (
        <ProjectBussy title="Načítám data..."/>
    )
}

export default Loading;
